import { createContext } from 'react';
import { LookupsStore } from '@gp/offer';

const defaultValue: LookupsStore = new LookupsStore();
export const LookupContext = createContext<LookupsStore>(defaultValue);